import widgetData from './widgetDataReducer';
import http from './httpReducer';
import appliedMainFilters from './appliedMainFiltersReducer';
import appliedModalFilters from './appliedModalFiltersReducer';
import mainFacetData from './mainFacetDataReducer';
import modalFacetData from './modalFacetDataReducer';

const root = {
	widgetData,
	http,
	appliedMainFilters,
	appliedModalFilters,
	mainFacetData,
	modalFacetData
};

export default root;
